<template>
  <div class="reply-list">
    <div class="add-area show van-hairline--bottom" v-if="list.length">
      <div class="add-area__info">回评问卷：{{ totalCount }}</div>
      <div class="add-btn" @click="addreply" v-if="totalCount < 10">
        <van-icon name="plus" />
        &nbsp;
        <div class="add-btn__text">新增回评问卷</div>
      </div>
    </div>
    <vx-list
      enable
      class="main-wrapper mb"
      :api="api"
      :params="params"
      @load="onLoad"
      ref="listScroller"
    >
      <div class="reply-box" v-for="item in list" :key="item.id">
        <div class="item-title van-hairline--bottom">
          <div class="item-top">
            <div class="item-name">{{ item.title }}</div>
            <div class="edit" v-if="item.id !== setQandaId">
              <van-icon
                name="delete-o"
                class="operation-icon"
                size="16"
                @click.stop="gotoDelete(item)"
              />
            </div>
          </div>
        </div>
        <div class="item-content">
          {{ item.questions.map(item => item.title).join('、') }}
        </div>
      </div>
      <empty-page :show="list.length === 0" tips="还没有回评问卷~">
        <van-button type="primary" square round @click="addreply">新增回评问卷</van-button>
      </empty-page>
    </vx-list>
  </div>
</template>

<script>
import emptyPage from '@teacher/components/empty-page.vue';

export default {
  name: 'replyList',
  components: {
    emptyPage,
  },
  data() {
    return {
      pageTitle: '回评问卷管理',
      list: [],
      api: this.$api.getQanda,
      totalCount: 0,
      showPopover: {},
      setQandaId:'',
      params: {
        businessType: 2,
      },
    };
  },
  methods: {
    onLoad(list, res) {
      this.list = list;
      this.totalCount = res && res.page && res.page.totalCount;
      vant.Toast.clear();
    },
    addreply() {
      this.$router.push('/comment-reply-add');
    },
    async gotoDelete(item) {
      await this.$dialog.confirm({
        message: `删除后，已有回评记录仍存在，数据统计将无法展示，是否确认删除？`,
        confirmButtonText: '确认删除',
        confirmButtonColor:'var(--c3)',
        cancelButtonText: '取消',
      });
      this.$api.deleteQanda(item.id).then(res => {
        this.$toast.success('删除成功');
        app.vue.$emit('comment-reply-list-refresh');
      });
    },
  },
  created() {
    this.$api.getCommentSet().then(res => {
      this.setQandaId = res.data.qandaId;      
    });
    this.$onBus('comment-reply-list-refresh', () => {
      this.$set(this.params, '_refreshFlag_', Date.now());
    });
  },
};
</script>

<style lang="scss" scoped>
.reply-list {
  display: flex;
  flex-direction: column;
  background-color: var(--g1);
  font-size: var(--fs-md);
  .main-wrapper {
    flex: 1;
    .reply-box {
      background-color: var(--white);
      margin: calc(var(--gap) * 12) calc(var(--gap) * 16) 0;
      border-radius: var(--radius-sm);
      .item-title {
        padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
        .item-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          color: var(--g8);
          font-weight: var(--bold);
        }
        .operation-icon {
          color: var(--g6);
        }
        .item-extra {
          color: var(--g5);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          margin-top: calc(var(--gap) * 2);
          margin-bottom: calc(var(--gap) * 8);
          display: flex;
          align-items: center;
          .icon {
            margin-right: calc(var(--gap) * 4);
          }
        }
      }
      .item-content {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
      }
    }
  }
}
</style>

<style lang="scss">
.reply-list-popover {
  width: 128px;
  padding: 0 calc(var(--gap) * 16);
  .popover-item {
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: var(--fs-md);
    color: var(--g8);
  }
}
</style>